import { createDrawerNavigator } from '@react-navigation/drawer';
import { LatoFonts } from '../../theme';
import React from 'react';
import { Platform } from 'react-native';
import CustomDrawer from './components/CustomDrawer';
import HomeHeader from '../../components/Reusables/headers/HomeHeader';
import HeaderTitle from '../../components/Reusables/headers/HeaderTitle';
import HeaderLocationPicker from '../../components/Reusables/headers/HeaderLocationPicker';
import EmployeeHomeTabNavigator from '../TabNavigator/EmployeeHomeTabNavigator';
import Browser from '../../screens/Browser';
import { fs } from '../../utils/libs';
import { isTablet } from 'react-native-device-info';
import { useAppSelector } from '../../redux/helper';
import { RootState } from '../../redux/types';
import { isEmployeeAdminRole } from '../../utils/roles';

const Drawer = createDrawerNavigator();

const HomeHeaderTitle: React.FC<{ isAdmin: boolean }> = ({ isAdmin }) => {
  return isAdmin ? <HeaderLocationPicker /> : <HeaderTitle />;
};

const DrawerNavigation = () => {
  const employee = useAppSelector(
    (state: RootState) => state.auth.inApp.account.employeeInfo,
  );

  const isAdmin = isEmployeeAdminRole(employee?.bp_employee_role);
  return (
    <Drawer.Navigator
      drawerContent={props => <CustomDrawer {...props} />}
      screenOptions={{
        headerShown: false,
      }}>
      <Drawer.Screen
        name="Home"
        component={EmployeeHomeTabNavigator as any}
        options={{
          headerTitle: () => <HomeHeaderTitle isAdmin={isAdmin} />,
          headerRight: () => <HomeHeader />,
          headerTitleStyle: {
            color: '#fff',
            fontFamily: LatoFonts.regular,
            fontSize: fs(isTablet() ? 18 : 16),
            lineHeight: fs(20),
          },
          headerTitleContainerStyle:
            Platform.OS === 'web'
              ? { flex: 1, alignItems: 'center' as const }
              : undefined,
          headerShown: true,
          headerTintColor: '#fff',
          headerTitleAlign: Platform.OS === 'web' ? 'center' : 'left',
          headerStyle: {
            backgroundColor: '#1560bd',
          },
        }}
      />
      {/* <Stack.Screen
        name="Browser"
        component={Browser}
        options={{
          headerTintColor: '#fff',
          headerShown: false,
          headerStyle: {
            backgroundColor: '#1560bd',
          },
        }}
      /> */}
      <Drawer.Screen
        name="Browser"
        component={Browser}
        options={{
          headerTintColor: '#fff',
          headerShown: false,
          headerStyle: {
            backgroundColor: '#1560bd',
          },
        }}
      />
    </Drawer.Navigator>
  );
};

export default DrawerNavigation;
